<div class="flex flex-row h-full w-full">
  <!-- Login / RegistrationHalf Page -->
  <div class="w-full xl:w-1/2 min-h-full overflow-y-auto flex flex-col relative box-border">
    <div class="flex items-center justify-between w-full px-4 sm:px-6 md:px-8 xl:px-10 pt-4 sm:pt-6 pb-4 sm:pb-6 flex-shrink-0">
      <img src="logo-thalea.svg" class="w-20.5 flex-shrink-0" />

      @if (activeFormTab() === 'login') {
        <div class="flex text-sm flex-col gap-0 items-end sm:flex-row sm:gap-1 sm:items-center">
          <span>Non hai ancora un account?</span>
          <button
            variant="link"
            (click)="onBackToQuestionnaire()"
            class="px-0 py-1 underline whitespace-nowrap"
            hlmBtn
          >
            Registrati
          </button>
        </div>
      } @else {
        <div class="flex items-center text-sm gap-1">
          <span>Hai già un account?</span>
          <button
            variant="link"
            (click)="onBackToLogin()"
            class="px-0 py-1 underline whitespace-nowrap"
            hlmBtn
          >
            Accedi
          </button>
        </div>
      }
    </div>

    <div class="flex flex-col items-center justify-center flex-1 px-4 sm:px-6 md:px-8 xl:pl-10 xl:pr-20 w-full py-4 sm:py-6 md:py-8">
      <div class="w-full max-w-md xl:max-w-none">
        @if (showTotpVerification()) {
          <auth-totp-verification
            (verificationSuccess)="onTotpVerificationSuccess($event)"
            (verificationCancel)="onTotpVerificationCancel()"
          ></auth-totp-verification>
        } @else {
          <keus-login-and-registration-form
            [form]="authForm"
            [isLoading]="isLoading()"
            [activeTab]="activeFormTab()"
            (submitEvent)="manageSigns($event)"
            (resetPasswordEvent)="onResetPasswordClick()"
            (tabChangeEvent)="onTabChange($event)"
          ></keus-login-and-registration-form>
        }
      </div>
    </div>

    <!-- Spacer for bottom padding -->
    <div class="h-6 sm:h-8 md:h-10 flex-shrink-0"></div>
  </div>

  <!-- Banner Half Page -->
  <div class="hidden xl:flex flex-col bg-(--bordeaux-800) fixed w-1/2 h-full right-0 top-0 py-14 px-9 justify-between ">
    <!-- Background pattern -->
    <img src="auth-banner-pattern.png" class="absolute h-full w-full right-0 top-0 object-cover z-0" />

    <!-- Title and subtitle section -->
    <div class="flex flex-col gap-1.25 mb-10 w-full z-10">
      <h1 class="text-white text-5xl font-semibold">
        {{
        activeFormTab() === 'login' ?
        'Bentornato in Talea' :
        'Il tuo primo colloquio ti sta aspettando'
        }}
      </h1>

      <p class="text-white text-lg font-normal">
        {{ 
        activeFormTab() === 'login' ?
        'Accedi per riprendere il tuo percorso.' :
        'Sei pronto per saperne di più sulla tua fertilità?' 
        }}
      </p>
    </div>

    <!-- Fertility check-in bundle -->
    @if (activeFormTab() === 'registration') {
      <div class="flex flex-col gap-1.5 z-10">
          <p class="text-base font-medium text-white">
              Il Fertility Check-in include:
          </p>
          <div class="flex items-start flex-col text-sm text-white gap-1.5">
              <div class="flex items-center gap-2">
                  <ng-icon name="lucideCircleCheckBig" hlm size="sm" class="fill-white"></ng-icon>
                  <p>Consulenza iniziale con il tuo Medico Specialista.</p>
              </div>
              <div class="flex items-center gap-2">
                  <ng-icon name="lucideCircleCheckBig" hlm size="sm" class="fill-white"></ng-icon>
                  <p>Revisione completa della tua storia medica.</p>
              </div>
              <div class="flex items-center gap-2">
                  <ng-icon name="lucideCircleCheckBig" hlm size="sm" class="fill-white"></ng-icon>
                  <p>Piattaforma Talea per monitoraggio dei progressi.</p>
              </div>
              <div class="flex items-center gap-2">
                  <ng-icon name="lucideCircleCheckBig" hlm size="sm" class="fill-white"></ng-icon>
                  <p>Set di esami e test specifici adatti alla tua storia clinica.</p>
              </div>
              <div class="flex items-center gap-2">
                  <ng-icon name="lucideCircleCheckBig" hlm size="sm" class="fill-white"></ng-icon>
                  <p>Fertility Report e consulenza finale con il tuo Medico Specialista.</p>
              </div>
          </div>
      </div>
    }
    
    <!-- Happy people bottom image -->
    <div class="flex flex-1 w-full max-h-1/2 justify-center items-end relative">
      <img src="happy-people-transparency.png" class="h-full w-auto z-1" />
    </div>
  </div>

  <!-- Gradient -->
  <div class="hidden xl:block fixed bottom-0 w-1/2 h-1/4 right-0 bg-gradient-to-t from-[#6A0635] from-30% to-transparent z-10 block-border"></div>
</div>



<hlm-dialog closeOnBackdropClick="false">
  <hlm-dialog-content *brnDialogContent="let ctx" class="w-9/10 sm:max-w-lg mx-auto rounded-lg overflow-hidden">
    <thalea-questionnaire-dialog 
      title="Solo un ultimo sforzo!"
      content="Hai completato il questionario preliminare con successo, ora puoi procedere con la registrazione."
      (close)="ctx.close()"
    />
  </hlm-dialog-content>
</hlm-dialog>